<template>
  <div>
    <v-alert
      :value="alert"
      type="info"
      color="info"
      transition="scale-transition"
    >
      <v-layout align-center wrap>
        <v-flex md6>
          <p>Realización de Pagos</p>
          <p>Cantidad de multas: {{ count }}</p>
        </v-flex>
        <v-flex md6>
          <p>Total: {{ this.montosTotales }} $</p>
          <span>El monto del pago debe ser igual al total</span>
        </v-flex>
      </v-layout>
    </v-alert>
  </div>
</template>
<script>
export default {
  props: {
    count: "",
    multa: [],
  },
  data() {
    return {
      loading: false,
      alert: true,
      itemsMontos: [],
      lista: [],
    };
  },

  created() {
    this.loadData();
  },
  methods: {
    callToContratacionMultiple() {
      this.$parent.multipleContratacion();
      this.loading = true;
      this.$parent.reload();
      this.loading = false;
    },
    async loadData() {
      var response = this.multa;
      this.itemsMontos = response;
      this.loadListaSelect();
    },
    loadListaSelect() {
      let mon = [];
      let ids = [];
      this.itemsMontos.forEach(function (p) {
        let index = mon.findIndex((x) => x.monto == p.monto);
        if (index === -1) {
          mon.push(p.monto);
          ids.push({ id: p.id });
        }
      });
      this.montosSelect = mon;
      this.$parent.$parent.$parent.$parent.listaIdMultas = ids;
      let suma = mon.reduce((ant, act) => {
        return parseInt(ant) + parseInt(act);
      });
      this.montosTotales = suma;
    },
  },
};
</script>
